import React from 'react'
import { Download, Upload } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog'
import { Button } from '@/app/components/ui/button'

interface ImportModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ImportModal({ open, onOpenChange }: ImportModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Importar Productos desde Excel</DialogTitle>
          <DialogDescription className="sr-only">
            Cargar productos masivamente desde un archivo Excel
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
            <p className="mb-2 text-sm font-medium text-blue-900">
              Instrucciones:
            </p>
            <ol className="list-inside list-decimal space-y-1 text-sm text-blue-800">
              <li>Descarga la plantilla de Excel</li>
              <li>Completa los datos de los productos</li>
              <li>Sube el archivo completo</li>
            </ol>
          </div>

          <Button variant="outline" className="w-full">
            <Download className="mr-2 h-4 w-4" />
            Descargar Plantilla Excel
          </Button>

          <div className="rounded-lg border-2 border-dashed border-slate-200 p-6 text-center">
            <input
              type="file"
              accept=".xlsx,.xls"
              className="hidden"
              id="excel-upload"
            />
            <label htmlFor="excel-upload" className="cursor-pointer">
              <Upload className="mx-auto mb-2 h-12 w-12 text-slate-400" />
              <p className="text-sm text-slate-600">
                Haz clic para seleccionar archivo
              </p>
              <p className="mt-1 text-xs text-slate-500">
                Solo archivos .xlsx o .xls
              </p>
            </label>
          </div>

          <Button className="w-full">Importar Productos</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
